export const BPMN_ACTION_TYPE = "BPMN_ACTION_TYPE";
export const COLORPIC_CONTEXT = "COLORPIC_CONTEXT";
export const DROPSHADOW_VISIBILITY = "DROPSHADOW_VISIBILITY";
export const BACKGROUND_MENU_VISIBILITY = "BACKGROUND_MENU_VISIBILITY";
export const BORDER_VISIBILITY = "BORDER_VISIBILITY";
export const FONTSTYLES_VISIBILITY = "FONTSTYLES_VISIBILITY";
export const TEXT_EDITOR_VISIBILITY = "TEXT_EDITOR_VISIBILITY";
export const SET_BPMN_TARS_VISIBILITY = "SET_BPMN_TARS_VISIBILITY";
export const ERROR_FONTSTYLES_VISIBILITY = "ERROR_FONTSTYLES_VISIBILITY"
export const SET_FUNCTIONS_LIST = 'SET_FUNCTIONS_LIST'
